import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Form, Input, Row } from 'reactstrap';
import { useAu1FindAllQuery, useAu2FindAllQuery, useAu3FindAllQuery, useBasinFindAllQuery, useCommonDataFindAllQuery, useStatusFindAllQuery } from 'store';

import { useFormik } from "formik";

const Filter = ({ setSearchField, f_basin_code, f_au1_code, f_au2_code, f_au3_code, f_name, f_code, f_save_border, f_commonType, f_status, f_decision_no }: any) => {

  const [au1Selected, setAu1Selected] = useState<string>('');
  const [au2Selected, setAu2Selected] = useState<string>('');


  const {
    data: basinData,
    error: basinError,
    isFetching: isBasinFetching,
  } = useBasinFindAllQuery();

  const {
    data: au1Data,
    error: au1Error,
    isFetching: isAu1Fetching,
  } = useAu1FindAllQuery();

  const {
    data: au2Data,
    error: au2Error,
    isFetching: isAu2Fetching,
  } = useAu2FindAllQuery(`?au1_code=${au1Selected}`);

  const {
    data: au3Data,
    error: au3Error,
    isFetching: isAu3Fetching,
  } = useAu3FindAllQuery(`?au1_code=${au1Selected}&au2_code=${au2Selected}`);

  const {
    data: commonData,
    error: commonDataError,
    isFetching: isCommonDataFetching,
  } = useCommonDataFindAllQuery(`?group_name=${f_commonType}`);

  const { data: statusData } = useStatusFindAllQuery();

  useEffect(() => {
    console.log(f_commonType);

  }, [au1Data, au2Data, au3Data, basinData, au1Selected, au2Selected])

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      basin_code: '',
      au3_code: '',
      name: '',
      code: '',
      status_id: '',
      decision_no: '',
      save_border: '',
      f_commonType: ''
    },
    onSubmit: (values: any) => {
      let search = "";
      if (values['basin_code']) search += "basin_code=" + values['basin_code'] + '&';
      if (au1Selected) search += "au1_code=" + au1Selected + '&';
      if (au2Selected) search += "au2_code=" + au2Selected + '&';
      if (values['au3_code']) search += "au3_code=" + values['au3_code'] + '&';
      if (values['name']) search += "name[iLike]=" + values['name'] + '&';
      if (values['code']) search += "code[in]=" + values['code'] + '&';
      if (values['status_id']) search += "status_id=" + values['status_id'] + '&';
      if (values['decision_no']) search += "decision_no[iLike]=" + values['decision_no'] + '&';
      if (values[`${f_commonType}`]) search += `${f_commonType}=` + values[`${f_commonType}`] + '&';
      if (values['save_border']) search += "save_border=" + values['save_border'] + '';
      setSearchField(search)
    },
  });


  return (
    <React.Fragment>
      <Col xl={3}>
        <Card>
          <CardBody>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <h5 className="fw-semibold text-center">Хайлтын хэсэг</h5>
              {
                (f_basin_code &&
                  <Row className="mt-3">
                    <label className='fw-semibold' >Сав газар:</label>
                    <div >
                      <Input
                        name="basin_code"
                        type='select'
                        className='form-select'
                        {...validation.getFieldProps('basin_code')}
                      >
                        <option value="" disabled> Сонгох </option>
                        {basinData?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.id} :: {item?.basin_name}</option>
                        ))}
                      </Input>
                    </div>
                  </Row>
                )
              }

              {
                (f_au1_code &&
                  <Row className="mt-3">
                    <label className='fw-semibold' >Аймаг/Нийслэлийн нэр:</label>
                    <div >
                      <Input
                        name="au1_code"
                        type="select"
                        value={au1Selected}
                        onChange={(e) => setAu1Selected(e.target.value)}
                        className="form-select"
                      >
                        <option value="" disabled>Сонгох</option>
                        {au1Data?.data?.map((item, index) => (
                          <option key={index} value={item?.code}>
                            {item?.code} :: {item?.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                  </Row>
                )
              }

              {
                (f_au2_code &&

                  <Row className="mt-3">
                    <label className='fw-semibold'>Сум/Дүүрэг:</label>
                    <div >
                      <Input
                        name="au2_code"
                        type="select"
                        value={au2Selected}
                        onChange={(e) => setAu2Selected(e.target.value)}
                        className="form-select"
                      >
                        <option value="" disabled> Сонгох </option>
                        {au2Data?.data?.map((item, index) => (
                          <option value={item?.code}>{item?.code} :: {item?.name}</option>
                        ))}
                      </Input>
                    </div>
                  </Row>
                )
              }

              {
                (f_au3_code &&
                  <Row className="mt-3">
                    <label className='fw-semibold' >Баг/Хороо:</label>
                    <div >
                      <Input
                        name="au3_code"
                        type='select'
                        className='form-select'
                        {...validation.getFieldProps('au3_code')}
                      >
                        <option value="" disabled> Сонгох </option>
                        {au3Data?.data?.map((item, index) => (
                          <option value={item?.code}>{item?.code} :: {item?.name}</option>
                        ))}
                      </Input>
                    </div>
                  </Row>
                )
              }

              {
                (f_name &&
                  <Row className="mt-3">
                    <label className='fw-semibold' >Нэр:</label>
                    <div >
                      <Input
                        type="text"
                        name="name"
                        className='form-control'
                        {...validation.getFieldProps('name')}
                      />
                    </div>
                  </Row>
                )
              }

              {
                (f_code &&
                  <Row className="mt-3">
                    <label className='fw-semibold' >Бүртгэлийн дугаар:</label>
                    <div >
                      <Input
                        type="text"
                        name="code"
                        className='form-control'
                        {...validation.getFieldProps('code')}
                      />
                    </div>
                  </Row>
                )
              }

              {
                (f_commonType &&
                  <Row className="mt-3">
                    <label className='fw-semibold' >Төрөл:</label>
                    <div >
                      <Input
                        name={f_commonType}
                        type='select'
                        className='form-select'
                        {...validation.getFieldProps(`${f_commonType}`)}
                      >
                        <option value=""> Бүгд </option>
                        {commonData?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}
                      </Input>
                    </div>
                  </Row>
                )
              }

              {
                (f_status &&
                  <Row className="mt-3">
                    <label className='fw-semibold'>Төлөв:</label>
                    <div>
                      <Input type="select" name="status_id" className="form-select" {...validation.getFieldProps('status_id')}>
                        <option value="">Бүгд</option>
                        {statusData?.data?.map((item: any) => (
                          <option key={item.id} value={item.id}>{item.name}</option>
                        ))}
                      </Input>
                    </div>
                  </Row>
                )
              }

              {
                (f_decision_no &&
                  <Row className="mt-3">
                    <label className='fw-semibold'>Тогтоолын дугаар:</label>
                    <div>
                      <Input type="text" name="decision_no" className="form-control" {...validation.getFieldProps('decision_no')} />
                    </div>
                  </Row>
                )
              }

              {
                (f_save_border &&
                  <Row className="mt-3">
                    <label className='fw-semibold'>Хамгаалалтын бүс тогтоосон эсэх:</label>
                    <div >
                      <Input
                        type="select"
                        name="save_border"
                        className='form-control form-select'
                        {...validation.getFieldProps('save_border')}
                      >
                        <option value="" disabled> Сонгох </option>
                        <option value="false"> Байхгүй </option>
                        <option value="true"> Байгаа </option>
                      </Input>
                    </div>
                  </Row>
                )
              }
              <Row className="mt-3">
                <div className="hstack gap-2 justify-content-center">
                  <button
                    type="submit"
                    className="btn btn-primary  btn-label"
                  >
                    <i className="mdi mdi-filter-plus-outline label-icon"></i> Шүүлт
                  </button>
                </div>
              </Row>
            </Form>
          </CardBody>
        </Card>

      </Col>
    </React.Fragment>
  );
}

export default Filter;
